module.exports = __webpack_public_path__ + "static/media/logo_08.962ddac5.png";